import { useRef } from "react";
import { Turnstile as CFTurnstile, type TurnstileInstance } from "@marsidev/react-turnstile";
import { TURNSTILE_SITE_KEY } from "../../constants";

interface TurnstileProps {
    onComplete: (token: string) => void;
    onReset?: () => void;
    disabled?: boolean;
    /**
     * Bump to discard a spent challenge and mount a fresh widget. Cloudflare
     * tokens are single-use, so a consumed one can never be verified again —
     * callers must bump this after any submit that used the token, otherwise
     * `onComplete` never fires again and the form can only recover on reload.
     */
    resetSignal?: number;
}

const Turnstile = ({ onComplete, onReset, disabled = false, resetSignal = 0 }: TurnstileProps) => {
    const ref = useRef<TurnstileInstance | null>(null);

    const handleExpireOrError = () => {
        ref.current?.reset();
        onReset?.();
    };

    return (
        <div className={`w-full min-w-0 max-w-full overflow-hidden [&_iframe]:!max-w-full ${disabled ? "pointer-events-none opacity-60" : ""}`}>
            <CFTurnstile
                key={resetSignal}
                ref={ref}
                siteKey={TURNSTILE_SITE_KEY}
                onSuccess={onComplete}
                onExpire={handleExpireOrError}
                onError={handleExpireOrError}
                options={{ theme: "auto", size: "flexible" }}
                style={{ width: "100%" }}
            />
        </div>
    );
};

export default Turnstile;
